import { ENVS, getAccOrigin, getEnv } from '@adsk/acs-sc-web-platform-api';
import { SEGMENT_PRODUCTION_KEY, SEGMENT_STAGING_KEY } from './segmentApiKeysConsts';
import { REACT_APP_SEGMENT_API_KEY, REACT_APP_DISABLE_SEGMENT, NODE_ENV } from '../env';

/**
 * Segment API Keys
 *
 * These are client-side keys, so they are safe to include in Javascript we send to customers.
 */
const SEGMENT_API_KEYS = Object.freeze({
  [ENVS.PRODUCTION]: SEGMENT_PRODUCTION_KEY,
  [ENVS.STAGING]: SEGMENT_STAGING_KEY
});
const VALID_ORIGINS = [getAccOrigin(),
// API client returns origin instead of hostname
'https://revit-issues.b360-qa.autodesk.com', 'https://revit-issues.b360-staging.autodesk.com', 'https://revit-issues.b360.autodesk.com', 'https://navisworks-issues.b360-qa.autodesk.com', 'https://navisworks-issues.b360-staging.autodesk.com', 'https://navisworks-issues.b360.autodesk.com', 'https://insight.b360-qa.autodesk.com', 'https://insight.b360-staging.autodesk.com', 'https://insight.b360-staging.eu.autodesk.com', 'https://insight.b360.autodesk.com', 'https://insight.b360.eu.autodesk.com', 'https://revit-integrations.b360-qa.autodesk.com', 'https://revit-integrations.b360-staging.autodesk.com', 'https://revit-integrations.b360.autodesk.com'];

/**
 * Returns the correct Segment API key for the given environment, or null if Segment should not be loaded.
 */
export default function segmentApiKey() {
  if (REACT_APP_DISABLE_SEGMENT === 'true') return null;

  // We only initialize Segment on ACC.
  if (!VALID_ORIGINS.includes(window.location.origin)) return null;

  // if REACT_APP_SEGMENT_API_KEY (or window.SEGMENT_API_KEY) is set to a non-empty string, always use that.
  const key = REACT_APP_SEGMENT_API_KEY || window.SEGMENT_API_KEY;
  if (typeof key === 'string' && key.length > 0) return key;
  const ENV = getEnv();
  const {
    hostname
  } = window.location;
  if (NODE_ENV !== 'production' || !ENV) return null;

  // Prevent Cypress production builds from triggering analytics events
  if (ENV === ENVS.PRODUCTION && hostname !== 'localhost' && hostname.indexOf('local.') < 0) {
    return SEGMENT_API_KEYS[ENVS.PRODUCTION];
  } else if (ENV === ENVS.STAGING || ENV === ENVS.QA) {
    return SEGMENT_API_KEYS[ENVS.STAGING];
  } else {
    const reason = typeof ENV === 'string' ? "env set to '".concat(ENV, "', which is unsupported") : "env isn't set";
    console.warn("Segment not loaded because ".concat(reason, "."));
  }
  return null;
}
//# sourceMappingURL=segmentApiKey.js.map